import React from 'react'
import PropTypes from 'prop-types'
import AboutLocationContent from './AboutLocationContent'
import { connect } from 'dva'
import SidebarDetailHeader from '../SidebarDetailHeader'
import styles from './AboutLocation.module.scss'
import { STATES_DATA } from '../../../lib/constants'
import { metersToFeet } from '../../../lib/utils'

function AboutLocationSidebar(props) {
	const { assetsUrl, layersAtLocationData } = props
	const { county, layersAtLocation, overlaysAtLocation, point } = layersAtLocationData
	const stateName = layersAtLocation.length > 0 ? layersAtLocation[0].layer.state : layersAtLocationData.state
	const stateIcon = `${assetsUrl}/states/icons/small/${STATES_DATA[stateName]?.abbrev.toLowerCase()}.png`
	let sidebarHeaderTitle = 'About this Location'
	if (county) {
		sidebarHeaderTitle = county
		if (stateName) {
			sidebarHeaderTitle += `, ${STATES_DATA[stateName].abbrev}`
		}
	}
	return (
		<>
			<SidebarDetailHeader
				title={sidebarHeaderTitle}
				titleIcon={stateName ? <img width='24' height='24' src={stateIcon} /> : null}
				style={{ paddingBottom: '16px' }}
			/>
			<div className={styles.locationBox}>
				<span>LAT: {props.hideCoords ? '--' : point[1].toFixed(6)}</span>
				<span>LON: {props.hideCoords ? '--' : point[0].toFixed(6)}</span>
				{point[2] > 0 && <span>ELV: {props.hideCoords ? '--' : Math.round(metersToFeet(point[2]))}</span>}
			</div>

			<AboutLocationContent layersAtLocation={layersAtLocation} overlaysAtLocation={overlaysAtLocation} />
		</>
	)
}

AboutLocationSidebar.propTypes = {
	assetsUrl: PropTypes.string,
	hideCoords: PropTypes.bool,
	layersAtLocationData: PropTypes.object,
}

export default connect((model) => {
	return {
		assetsUrl: model.app.config.GH_ASSETS_CLOUDFRONT_URL,
		layersAtLocationData: model.layers.layersAtLocationData,
		hideCoords: model.app.hideCoords,
	}
})(AboutLocationSidebar)
